  <div>
    <div class="col-md-12 col-lg-12">
      <div class="col-sm-3"><h4><b>{{ 'pages.createReceiptPage.productGroup' | translate}}</b></h4></div>
      <div [@openClose]="!isOpen ? 'open' : 'closed'">
        <div class="col-sm-3"><h4>{{selectedProductGroup}}</h4></div>
        <div class="col-sm-3"><h4 class="change {{enableChange? '':'disabled'}}" (click)="change()">{{'common.change' | translate}}</h4></div>
      </div>
    </div>
  </div>
  <div class="mrgin-lft"  [@openClose]="isOpen ? 'open' : 'closed'">
    <div class="col-md-3 col-sm-10">
      <button class="btn btn-lg r btn-mode" (click)="selectProductGroup('DOM')"><span class="armx-icon armx-dom"></span>{{'common.domestic' | translate}}</button>
    </div>
    <div class="col-md-3 col-sm-10">
      <button class="btn btn-lg r btn-mode" (click)="selectProductGroup('EXP')"><span class="armx-icon armx-exp"></span>{{'common.express' | translate}}</button>
    </div>
  </div>

